import React, { FC, ReactElement, useState } from "react";
import WizardSideBarStep from "../../../models/WizardSideBarStep";
import Wizard from "../../wizard/wizard";
import { Summary } from "./summary-step";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Detail } from "./detail-step";

interface DynamicDateWizardProps {
    defaultContent: ReactElement[];
    defaultSteps: WizardSideBarStep[];
    onClose: () => void;
    selectedCategory: string;
    onBack: (event: any) => void;
    onWeekDatesChange?: (start: Date, end: Date) => void;
}

const DynamicDateWizard: FC<DynamicDateWizardProps> = ({ defaultContent, defaultSteps, onClose, selectedCategory, onBack, onWeekDatesChange }) => {
    const { translate } = useLocale();
    const [step, setStep] = useState<number>(2);

    const content: ReactElement[] = [
        ...defaultContent,
        <Detail
            key={"wizard-3"}
            onBack={onBack}
            onNext={() => setStep(step + 1)}
            onWeekDatesChange={onWeekDatesChange} />,
        <Summary
            key={"wizard-4"}
            onBack={() =>  setStep(step - 1)}
            type={translate.byKey(TranslationKeys.dateFilter)}
            category={selectedCategory} />
    ]

    const steps: WizardSideBarStep[] = [
        ...defaultSteps,
        {
            title: translate.byKey(TranslationKeys.details),
            description: '',
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: '',
            substeps: []
        }
    ];

    return <Wizard name={translate.byKey(TranslationKeys.dataFilters)}
        step={step}
        onClose={() => onClose()}
        sidebarSteps={steps}>
        {content}
    </Wizard>
}

export default DynamicDateWizard;